import { Box, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import del from "../../Assets/delete.png";
import Edit from "../../Assets/edit.png";
import DataListingComponent from "../../Component/DataListingComponent";
import { API_GET_OPEN, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import FaqModal from "./AddFaqModal";
import ConfirmDeleteModal from "../../Component/Modal/ConfirmModal";
import { toast } from "react-toastify";

const PAGE_SIZE_OPTIONS = [15];
const FAQsManagement = () => {
  const [data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);
  const [id, setId] = useState("");
  const [modalData, setModalData] = useState({});
  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleEdit = (e) => {
    setId(e.id);
    setModalData(e);
    setOpen(true);
  };
  const handleDelete = (id) => {
    setId(id);
    setOpen1(true);
  };
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleClose = () => {
    setOpen1(false);
  };
  const handleConfirm = async () => {
    const f = new FormData();
    f.append("id", id);
    f.append("status", 0);
    try {
      let res = await API_POST(API_endspoints.updatefaq, f);
      if (res.s) {
        toast.success(res.m);
        GetFAQ();
        setOpen1(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 50,
      headerAlign: "center",
    },

    {
      headerClassName: "super-app-theme--header",
      field: "question",
      headerName: "Question",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },

    {
      headerClassName: "super-app-theme--header",
      field: "answer",
      headerName: "Answer",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "german_question",
      headerName: "German Question",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "german_answer",
      headerName: "German Answer",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "type",
      headerName: "Type",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.type == 1 ? (
          <span>Customer</span>
        ) : (
          <span style={{ color: "#fd5d29" }}>Caterer</span>
        ),
    },

    {
      headerClassName: "super-app-theme--header",
      field: "is_Active",
      headerName: "Action",
      width: 200,
      headerAlign: "center",
      renderCell: (cell) => {
        const data = cell?.row;
        return (
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1rem",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: 1,
              }}
            >
              <img
                className="ImgHover"
                src={Edit}
                alt="Edit"
                height={24}
                width={24}
                onClick={(e) => handleEdit(data)}
              />
              <img
                className="ImgHover"
                src={del}
                alt="View"
                height={24}
                width={24}
                onClick={() => handleDelete(data?.id)}
              />
            </Box>
          </Box>
        );
      },
    },
  ];

  const GetFAQ = async (page = 0, pageSize = PAGE_SIZE_OPTIONS[0]) => {
    setIsLoading(true);
    try {
      let count = page * pageSize;
      const res = await API_GET_OPEN(
        `${API_endspoints.getFAQ}?count=${count}&offset=99`
      );
      const Rowdata = res?.r?.map((data, i) => ({
        rowid: i + 1,
        ...data,
      }));
      if (res?.r?.length > 0) {
        setData(Rowdata);
        setTotalData(res?.c ?? 0);
        setIsLoading(false);
      } else {
        setData([]);
        setTotalData(0);
      }
      // setLoading(false);
      setIsLoading(false);
    } catch (error) {
      // setLoading(false);
      setIsLoading(false);
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    GetFAQ(page, rowsPerPage);
  }, [page, rowsPerPage]);

  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          {/* Food Truck Owner / Caterers Owner */}
          FAQs
        </Typography>
        <Box>
          <FaqModal
            GetFAQ={() => GetFAQ(page, rowsPerPage)}
            setOpen={setOpen}
            open={open}
            modalData={modalData}
            id={id}
            setId={setId}
            setModalData={setModalData}
          />
        </Box>
        <ConfirmDeleteModal
          open={open1}
          handleClose={handleClose}
          handleConfirm={handleConfirm}
          confirmText="Delete"
          title="Are you sure want to delete?"
          confirmColor="red"
        />
      </Box>

      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 115px)",
          width: "100%",
          p: 2,
        }}
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
      </Box>
    </Box>
  );
};

export default FAQsManagement;
